<div class="view-container">
  <div class="manufacturers">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Request Partnership</label>
        </div>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                <mat-label>Search companies by name</mat-label>
                <input matInput type="text"
                  [(ngModel)]="searchTerm"
                  (keyup.enter)="loadManufacturers()"
                  (keyup.esc)="searchTerm=''; loadManufacturers()"
                  name="searchTerm"
                  placeholder="Search Name">
                <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadManufacturers();">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row">
                <button type="submit" 
                  mat-flat-button color="primary"
                  [class.button-spinner]="loading"
                  [disabled]="loading"
                  (click)="loadManufacturers()"
                  matTooltip="Search">
                  <mat-icon>search</mat-icon> Search
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="contrast" [ngClass.lt-sm]="{'mat-card-inline-sm': true}" *ngFor="let item of manufacturers">
          <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxLayout.lt-sm="column"  fxLayoutAlign.lt-sm="start center">
              <img fxHide.sm class="product-company-logo" *ngIf="getCompanyLogo(item?.id)" [lazyLoad]="getCompanyLogo(item?.id)">
              <div fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="center center">
                <span [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | encodeHtml | highlight: searchTerm" [matTooltip]="item?.id"></span>
                <small class="text-info">{{ companyTypes[item.companyType] }}</small>
              </div>
            </div>
            <div fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
              <!-- <div [ngClass.lt-sm]="{'item-metadata': true}" *ngIf="item?.productCount > 0" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center">
                  <p fxHide.lt-md><small>products available</small></p>
                  <mat-icon [matBadge]="item?.productCount">kitchen</mat-icon>
                  <div fxHide.lt-sm class="product-separator">|</div>
                </div> -->
              <ng-container *ngIf="item?.dateModified">
                <p><small>member since</small></p>
                <div>&nbsp;{{ item.dateModified | date }}</div>
              </ng-container>
              <div fxLayoutAlign="end center" fxLayout="row">
                <button 
                  mat-icon-button color="accent"
                  aria-label="Request Partnership"
                  matTooltip="Request Partnership"
                  [class.button-spinner]="selectedCompany?.id === selectedCompanyId"
                  [disabled]="selectedCompany?.id === selectedCompanyId"
                  (click)="requestPartnership(item)">
                  <mat-icon>add_link</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>
